import type { ComponentChildren } from "preact";
import { useState } from "preact/hooks";
import type { AdminRole } from "../api/types.js";
import { Button, Panel } from "../ui.js";

/** A panel whose publish form opens under the header, for editors only. */
export function VersionedPanel({
  title,
  subtitle,
  role,
  formLabel,
  renderForm,
  children,
}: {
  title: string;
  subtitle: string;
  role: AdminRole;
  formLabel: string;
  renderForm(done: () => void, cancel: () => void): ComponentChildren;
  children: ComponentChildren;
}) {
  const [open, setOpen] = useState(false);
  const [nonce, setNonce] = useState(0);
  return (
    <Panel
      title={title}
      subtitle={subtitle}
      action={
        role === "editor" && !open ? (
          <Button onClick={() => setOpen(true)}>{formLabel}</Button>
        ) : undefined
      }
    >
      {role === "editor" && open ? (
        <div class="mb-3 border-b border-line pb-3">
          {renderForm(
            () => {
              setOpen(false);
              setNonce((value) => value + 1);
            },
            () => setOpen(false),
          )}
        </div>
      ) : null}
      <div key={nonce}>{children}</div>
    </Panel>
  );
}
